import { usePsfSharePageData } from 'src/app/pages/psf/share/pageContext';

type Result = ModelHookResult<{
	photo?: {
		url: string;
		mobileUrl: string;
	};
}>;

export function usePetitionMedia(): Result {
	const {
		data: {
			petition: { photo },
		},
	} = usePsfSharePageData();

	const photoUrl = !photo?.petitionMedium.processing ? photo?.petitionMedium.url : undefined;
	const photoMobileUrl = !photo?.petitionSmall.processing ? photo?.petitionSmall.url : undefined;

	return {
		data: {
			photo:
				photoUrl && photoMobileUrl
					? {
							url: photoUrl,
							mobileUrl: photoMobileUrl,
						}
					: undefined,
		},
	};
}
